import _classPrivateFieldLooseBase from "@babel/runtime/helpers/esm/classPrivateFieldLooseBase";
import _classPrivateFieldLooseKey from "@babel/runtime/helpers/esm/classPrivateFieldLooseKey";
var _expire = /*#__PURE__*/_classPrivateFieldLooseKey("expire");
var _value = /*#__PURE__*/_classPrivateFieldLooseKey("value");
export default class Token {
  constructor(string, options = {}) {
    Object.defineProperty(this, _expire, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _value, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldLooseBase(this, _expire)[_expire] = options.expire;
    _classPrivateFieldLooseBase(this, _value)[_value] = string;
  }
  get expire() {
    return _classPrivateFieldLooseBase(this, _expire)[_expire];
  }
  isExpired(now = Date.now() / 1000) {
    return _classPrivateFieldLooseBase(this, _expire)[_expire] ? now > _classPrivateFieldLooseBase(this, _expire)[_expire] : false;
  }
  toString() {
    return _classPrivateFieldLooseBase(this, _value)[_value];
  }
}
//# sourceMappingURL=Token.js.map